import React from "react";
import { Route, BrowserRouter as Router, Switch, Link } from "react-router-dom";
import FooterHome from "./FooterHome";

function Home(props) {
  return (
    <div
      className="Home"
      style={{ backgroundImage: "url(/images/background.png)" }}
    >
      <div className="row mx-0 align-items-center p-5">
        <div className="col-md-5 offset-md-1">
          <h1 className="font-weight-bold">
            The ultimate CV <br /> & Portfolio Check-List
          </h1>
          <div className="py-3 mainP">
            Are you a Web Developer,Data Scientist,Digital Marketer or a
            Designer? <br /> Have your CV and portfolio in check and create a 5
            star representation of your skills with this guide
          </div>
            <Link onClick={props.path} className="btn buttonHome px-4" to="/about">Step inside</Link>
        </div>
        <div className="col-md-6">
          <img className="pic" src={`/images/home.png`} />
        </div>
      </div>
      <FooterHome />
    </div>
  );
}

export default Home;
